<template>
  <b-card>
    <LoadingSpinner :loading="loading" :text="$lang.sending_data" />
    <registerSurveyFrom
      v-show="!loading"
      mode="add"
      :parentPermissions="parentPermissions"
      :keyValue="attachmentKeyValue"
      :runFinalSave="runFinalSave"
      :resetForm="resetForm"
      @submit="save"
      @close="back"
    />
  </b-card>
</template>

<script>
import registerSurveyFrom from "./forms/registerSurveyFrom.vue";
import { pathOr } from "ramda";
import LoadingSpinner from "@/components/base/LoadingSpinner";

export default {
  components: {
    registerSurveyFrom,
    LoadingSpinner,
  },
  data() {
    return {
      loading: false,
      attachmentKeyValue: null,
      runFinalSave: false,
      parentPermissions: ["admin"],
      resetForm: false,
    };
  },
  methods: {
    pathOr,
    back() {
      return this.$router.push({ name: "my_survey" });
    },
    async save(payload) {
      try {
        this.loading = true;
        const url = this.$config.api_url + this.$config.survey.survey;
        const response = await this.$httpService.post(url, payload);
        this.attachmentKeyValue = pathOr(null, ["data", "data"], response);
        this.runFinalSave = true;
        this.$notify.success(response.data.message);
        this.resetForm = true;
        this.back();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
